const endPoint = 'https://plusradiology-test.ifourtechlab.com';
const apiVersion = 'v2';

export const environment = {
    environmentType: 'plusradiology',
    appVersion: require("../../package.json").version, //Fetching vesion of application.

    production: true,
    endPoint: endPoint,
    apiVersion: apiVersion,
    apiUrl: `${endPoint}/api/${apiVersion}`
};
